<template>
  <div class="client-container">
    <el-row class="tcf-row">
      <el-col :span="24" class="card">
        <div class="card-body">
          <div class="card-title">
            客户主页
          </div>
          <div class="card-content" v-loading="loading" v-if="clientinfo.cid!=null">
            <el-row>
              <el-col :span="5">
                <el-row>
                  <el-col :span="16" class="client-info-row">
                    <span class="client-name">{{clientinfo.name}}</span>
                    <svg-icon icon-class="client_man" class="client-sex" v-if="clientinfo.sex === 1" />
                    <svg-icon icon-class="client_women" class="client-sex" v-if="clientinfo.sex === 0" />
                  </el-col>
                  <el-col :span="8" style="text-align: right">
                    <el-button type="text" v-if="clientinfo.status==1" size="small" icon="el-icon-edit" @click="editInfo">客户编辑</el-button>
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <el-tag size="mini" v-if="clientinfo.status==2" :disable-transitions="true">已签约</el-tag>
                    <el-tag size="mini" v-if="clientinfo.status==0" :disable-transitions="true" type="danger">已作废</el-tag>
                    <el-tag v-if="clientinfo.status==1" v-for="(tag,index) in clientinfo.tagList" :type="index==0?'success':index==1?'warning':''" size="mini" style="margin-right: 4px" :disable-transitions="true">{{tag.name}}</el-tag>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span v-if="clientinfo.isgoto==1" style="font-weight: bold;font-size: 12px">到店时间：{{clientinfo.gototime}}</span>
                    <el-tag type="danger" size="mini" v-if="clientinfo.isgoto==0" :disable-transitions="true">未到店</el-tag>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <i class="el-icon-phone"></i> {{clientinfo.tel}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <svg-icon icon-class="wechat" style="color:#606266;width: 13px;" /> {{clientinfo.wchat}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <i class="el-icon-location"></i> {{clientinfo.province}} {{clientinfo.city}} {{clientinfo.county}}
                    {{clientinfo.address}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <i class="el-icon-s-opportunity"></i> {{clientinfo.style}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <i class="el-icon-crop"></i> {{clientinfo.area}} m²
                  </el-col>
                  <el-col :span="24" class="client-info-row" style="color:#999;font-size:12px;">
                    备注：{{clientinfo.remark}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="19">
                <el-timeline>
                  <el-timeline-item v-if="clientinfo.status!==0" timestamp="" placement="top">
                    <el-button size="small" type="primary" @click="editFollow(null)">添加跟进</el-button>
                    <el-button size="small" @click="openHtqd">合同签订</el-button>
                    <el-button size="small" @click="viewRecord" type="success" plain>访问记录</el-button>
                    <el-button size="small" @click="exchangeFollow" type="warning" plain>交换跟进</el-button>
                    <el-button size="small" v-if="clientinfo.status===1" @click="voidClient" type="danger" plain>客户作废</el-button>
                  </el-timeline-item>
                  <el-timeline-item v-for="follow in followList" :timestamp="follow.time" placement="top">
                    <el-card>
                      <el-button v-if="follow.userid===user.userid&&follow.type===1&&clientinfo.status===1" @click="editFollow(follow)" class="follow-editbtn" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                      <h4 class="follow-txt"><el-tag v-if="follow.type==0" style="margin-right: 10px" size="mini" type="danger">作废</el-tag>{{follow.name}}</h4>
                      <p class="follow-content"> {{follow.content}}</p>
<!--                      <div class="photo">-->
<!--                        <el-avatar shape="square" :size="50" :src="follow.headurl" style="cursor: pointer;" />-->
<!--                      </div>-->
                      <div class="info">
<!--                        <div class="username">-->
<!--                          <span style="cursor: pointer;">{{ follow.name }}</span>-->
<!--                          <el-tag  size="mini" >作废</el-tag>-->
<!--                        </div>-->
<!--                        <div class="content">-->
<!--                          {{ follow.content }}-->
<!--                        </div>-->
                        <div class="imgs">
                          <el-image
                            v-for="img in follow.imgStrList"
                            fit="cover"
                            class="dynamic-img"
                            :src="img"
                            :preview-src-list="follow.imgStrList"
                          />
                        </div>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="编辑客户信息"
      :visible.sync="infodialogVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="infoForm" :model="infoForm" :rules="infoRules" label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="infoForm.name" maxlength="5" />
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="infoForm.tel" maxlength="11" minlength="11" />
        </el-form-item>
        <el-form-item label="微信" prop="weixin">
          <el-input v-model="infoForm.weixin" maxlength="20" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="infoForm.sex">
            <el-radio :label="2">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否到店" prop="isgoto">
          <el-radio-group v-model="infoForm.isgoto">
            <el-radio :label="0">未到店</el-radio>
            <el-radio :label="1">已到店</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="infoForm.isgoto === 1" label="到店时间" prop="gototime">
          <el-date-picker
            v-model="infoForm.gototime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择到店时间"
          />
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            v-model="infoForm.city"
            style="width:100%"
            :options="cityoptions"
            filterable
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="infoForm.address" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item label="意向风格" prop="style">
          <el-select v-model="infoForm.style" filterable clearable>
            <el-option v-for="style in styleList" :key="style.sid" :label="style.name" :value="style.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area" style="width: 300px;">
          <el-input v-model="infoForm.area">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分组" prop="groupid">
          <el-select v-model="infoForm.groupid" filterable :clearable="true">
            <el-option
              v-for="gitem in groupoptions"
              :key="gitem.value"
              :label="gitem.label"
              :value="gitem.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-checkbox-group v-model="infoForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{ titem.name }}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="infoForm.remark" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editinfoloading" @click="subClientInfo('infoForm')">立即提交</el-button>
          <el-button @click="infodialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      title="标签管理"
      :visible.sync="tagsDrawer"
      direction="rtl"
    >
      <div class="tags-container">
        <el-row>
          <div v-for="t in tagaoption" class="tags-item">
            <span>{{ t.name }}</span>
            <el-button v-if="t.userid != 0" type="danger" class="tags-del" icon="el-icon-close" circle @click="delTags(t.tagid)" />
          </div>
          <el-button size="small" icon="el-icon-plus" type="primary" plain @click="addTags">添加</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      :title="followTitle"
      :visible.sync="followVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="followForm" :model="followForm" :rules="rulesFollow"  label-position="right" label-width="75px" size="small">
<!--        <el-form-item label="跟进类型" prop="type" >-->
<!--          <el-select v-model="followForm.type" clearable style="width: 140px">-->
<!--            <el-option label="正常跟进" :value="1" />-->
<!--            <el-option label="作废" :value="0" />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="标签" v-if="followForm.dcfid==0" prop="labels">
          <el-checkbox-group v-model="followForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{titem.name}}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="跟进图片" prop="imgids">
          <MultiImg :limit="9" :old="oldimgList" :key="imgLoad" v-model="followForm.imgids" :size="'sm'" ></MultiImg>
        </el-form-item>
        <el-form-item label="跟进内容" prop="remark">
          <el-input type="textarea" v-model="followForm.remark" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editfollowloading" @click="submitFollow('followForm')">立即提交</el-button>
          <el-button @click="followVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="浏览记录"
      :visible.sync="viewVisible"
      width="50%">
      <div v-loading="dloading">
        <el-table
          :data="viewData"
          stripe
          style="width: 100%">
          <el-table-column
            label="类型"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type === 0 ">装修攻略</span>
              <span v-if="scope.row.type === 1 ">晒家</span>
              <span v-if="scope.row.type === 2 ">案例</span>
            </template>
          </el-table-column>
          <el-table-column
            label="封面图"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image
                :src="scope.row.imgurl"
                fit="cover"
                style="height: 40px;"
                :preview-src-list="[scope.row.imgurl]"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="style"
            label="风格"
            width="100"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="描述"
            min-width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="timeshow"
            label="浏览时间"
            width="200"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="合同签订"
      :visible.sync="htVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="htForm" :model="htForm" :rules="rulesHt"  label-position="right" label-width="75px" size="small">
        <el-form-item label="签订日期" prop="time">
          <el-date-picker
            v-model="htForm.time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="房屋标识" prop="name">
          <el-input v-model="htForm.name" maxlength="200" placeholder="建议使用所在小区命名" />
        </el-form-item>
        <el-form-item label="客户名称" prop="custname">
          <el-input v-model="htForm.custname" maxlength="10" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="htForm.tel" maxlength="11" minlength="11" />
        </el-form-item>
        <el-form-item label="房屋地址" prop="address">
          <el-input placeholder="请输入详细地址" v-model="htForm.address" maxlength="200" show-word-limit class="input-with-select">
            <el-cascader
              v-model="htForm.city"
              placeholder="请选择省/市/县区"
              slot="prepend"
              clearable
              style="width:200px"
              :options="cityoptions"
              filterable/>
            <el-button slot="append" @click="flushMap" icon="el-icon-place"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="房屋定位" prop="gps">
          <div style="color: #99a9bf;font-size: 12px"><i class="el-icon-info"></i> 当前GPS经纬度：<b v-if="htForm.lng!==null&&htForm.lng!==undefined&&htForm.lng!==''&&htForm.lat!==null&&htForm.lat!==undefined&&htForm.lat!==''">{{ htForm.lng }},{{ htForm.lat }}</b><b v-if="htForm.lng===null||htForm.lng===undefined||htForm.lng===''||htForm.lat===null||htForm.lat===undefined||htForm.lat===''">无</b></div>
          <div ref="map" class="txmap" v-show="htForm.lng!==null&&htForm.lng!==undefined&&htForm.lng!==''&&htForm.lat!==null&&htForm.lat!==undefined&&htForm.lat!==''" style="width: 100%;height: 300px"></div>
        </el-form-item>
        <el-form-item label="房屋风格" prop="style">
          <el-select v-model="htForm.style">
            <el-option
              v-for="item in styleList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area">
          <el-select v-model="htForm.area">
            <el-option
              v-for="item in areaList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋户型" prop="house">
          <el-select v-model="htForm.house">
            <el-option
              v-for="item in bedRoomList"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设计师" prop="designer">
          <el-select v-model="htForm.designer" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服" prop="customer">
          <el-select v-model="htForm.customer" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售内勤" prop="sales">
          <el-select v-model="htForm.sales" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目经理" prop="foreman">
          <el-select v-model="htForm.foreman" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="装修阶段" prop="stages">
          <el-checkbox-group v-model="htForm.stages">
            <el-checkbox v-for="item in stageList" :disabled="item.name==='竣工'||item.name==='验收'" :label="item.name" name="stages">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="费用清单" prop="costs">
          <el-card shadow="never" style="font-size: 12px">
            <div style="margin-bottom: 10px">
              费用总计：<span style="font-size:13px;font-weight: 500;color: #F56C6C">{{htForm.amount}}</span>
              <el-button icon="el-icon-plus" style="float: right" @click="addOther">添加费用</el-button>
            </div>
            <el-row v-for="(item, index) in htForm.costs" >
              <el-col :span="14">
                <el-form-item :prop="'costs.' + index +'.name'" :rules="amountRules.name">
                  <el-input v-model="item.name" maxlength="100" placeholder="请输入费用说明" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="padding-left: 6px">
                <el-form-item :prop="'costs.' + index +'.amount'" :rules="amountRules.amount">
                  <el-input v-model="item.amount" placeholder="金额" oninput="value=value.replace(/[-][^0-9.]/g,'')">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="text-align: right">
                <el-button :disabled="index===0" :type="index===0?'info':'danger'" @click="delOther(index)" icon="el-icon-delete" plain></el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-form-item>
        <el-form-item label="合同原件" prop="imgids">
          <MultiImg :limit="50" :key="htimgLoad" v-model="htForm.imgids" :size="'sm'" ></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="htloading" @click="submitHt()">立即提交</el-button>
          <el-button @click="htVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="交换跟进"
      :visible.sync="changeVisible"
      width="400px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="changeForm" :model="changeForm" :rules="rulesChange"  label-position="right" label-width="75px" size="small">
        <el-form-item label="原跟进人" prop="olduserid">
          <el-select v-model="changeForm.olduserid" disabled>
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交换给" prop="newuserid">
          <el-select v-model="changeForm.newuserid" filterable placeholder="请选择">
            <el-option
              v-for="item in deluserlst"
              :label="item.name"
              :value="item.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="changeloading" @click="SubExchange()">立即提交</el-button>
          <el-button @click="changeVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { validatePhoneNumber } from '@/utils/validate'
import {
  delDelClientTag, editDelClientInfo,
  editDelClientTag,
  getDelClientGroupList,
  getDelClientInfo,
  getDelClientTagList,
  editDelClientFollow,
  getDelClientFollowList,
  getDelClientShowHomeBrowse,
  getDelClientCaseBrowse,
  getDelClientStrategyBrowse, getBrowsinghistoryList, getStageDictionary, signDealerClientContract,
  exchangeFollowClient
} from '@/api/dealer'
import { getCity } from '@/utils/city'
import { getWxStyleList } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'
import { getDealerDetail } from '@/api/work'
import { getDealerGroupReport } from '@/api/group/group'
import qs from 'qs'
import { getAreaList, getBedRoomList } from '@/api/community'
export default {
  name: 'Delclienthomepage',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    const validateStages = (rule, value, callback) => {
      if (value.length > 2) {
        callback()
      } else {
        callback(new Error('至少选择一个装修阶段'))
      }
    }
    const validateAddress = (rule, value, callback) => {
      if (this.htForm.city.length <= 0) {
        callback(new Error('请选择省/市/县区'))
      } else {
        if (this.htForm.address !== null && this.htForm.address !== undefined && this.htForm.address.trim() !== '') {
          callback()
        } else {
          callback(new Error('请输入详细地址'))
        }
      }
    }
    const validateGPS = (rule, value, callback) => {
      if (this.htForm.lng !== null && this.htForm.lng !== undefined && this.htForm.lng !== '' && this.htForm.lat !== null && this.htForm.lat !== undefined && this.htForm.lat !== '') {
        callback()
      } else {
        callback(new Error('请选择房屋定位'))
      }
    }
    return {
      changeVisible: false,
      changeloading: false,
      viewVisible: false,
      dloading: false,
      viewData: [],
      bid: 0,
      cid: undefined,
      cuserid: null,
      loading: false,
      tagsDrawer: false,
      clientinfo: {},
      infodialogVisible: false,
      editinfoloading: false,
      cityoptions: getCity(),
      groupoptions: [],
      tagaoption: [],
      styleList: [],
      areaList: [],
      bedRoomList: [],
      followList: [],
      infoForm: {
        name: '',
        tel: '',
        weixin: '',
        sex: null,
        city: [],
        address: '',
        style: '',
        area: '',
        labels: [],
        groupid: null,
        remark: '',
        gototime: '',
        isgoto: null,
        amount: 0
      },
      infoRules: {
        name: [{ required: true, message: '请输入客户真实姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        isgoto: [{ required: true, message: '请选择是否到店', trigger: 'change' }],
        gototime: [{ required: true, message: '请选择到店时间', trigger: 'blur' }]
      },
      followVisible: false,
      followTitle: '',
      followForm: {
        dcfid: 0,
        type: 1,
        labels: [],
        remark: '',
        imgids: []
      },
      oldimgList: [],
      imgLoad: '',
      rulesFollow: {
        remark: [{ required: true, message: '请填写跟进内容', trigger: 'blur' }]
      },
      editfollowloading: false,
      browsetype: 1,
      browsePageSize: 20,
      browseCurrentPage: 1,
      browsetotal: 0,
      browseLoading: false,
      browseList: [],
      htVisible: false,
      htimgLoad: '',
      htloading: false,
      htForm: {
        time: '',
        name: '',
        custname: '',
        tel: '',
        city: [],
        address: '',
        lng: '',
        lat: '',
        style: '',
        area: '',
        house: '',
        designer: null,
        customer: null,
        sales: null,
        foreman: null,
        stages: [],
        costs: [],
        imgids: []
      },
      rulesHt: {
        time: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        name: [{ required: true, message: '请输入房屋标识', trigger: 'blur' }],
        custname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        city: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
        address: [{ required: true, trigger: 'blur', validator: validateAddress }],
        designer: [{ required: true, message: '请选择设计师', trigger: 'change' }],
        customer: [{ required: true, message: '请选择客服', trigger: 'change' }],
        foreman: [{ required: true, message: '请选择项目经理', trigger: 'change' }],
        stages: [{ required: true, validator: validateStages, trigger: 'change' }],
        costs: [{ required: true, message: '请添加费用', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传合同原件', trigger: 'change' }],
        gps: [{ required: true, trigger: 'change', validator: validateGPS }],
        style: [{ required: true, message: '请选择房屋风格', trigger: 'change' }],
        area: [{ required: true, message: '请选择房屋面积', trigger: 'change' }],
        house: [{ required: true, message: '请选择房屋户型', trigger: 'change' }],
      },
      deluserlst: [],
      stageList: [],
      amountRules: {
        name: [{ required: true, message: '请输入费用说明', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入费用金额', trigger: 'blur' }]
      },
      changeForm: {
        olduserid: null,
        newuserid: null
      },
      rulesChange: {
        olduserid: [{ required: true, message: '请选择人员', trigger: 'change' }],
        newuserid: [{ required: true, message: '请选择人员', trigger: 'change' }]
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.cid = this.$route.params && this.$route.params.id
    this.getData()
    this.getBrandList()
    this.getDelClientGroupList()
    this.getDelClientTagList()
    this.getDealerGroup()
    this.getStageList()
    this.getBedRoomList()
    this.getAreaList()
  },
  watch: {
    'htForm.costs': {
      handler(newValue, oldValue) {
        let _amount = 0
        for (const c of this.htForm.costs) {
          if (c.amount !== null && c.amount !== '' && c.amount !== undefined) {
            _amount = _amount + parseFloat(c.amount)
          }
        }
        this.htForm.amount = _amount.toFixed(2)
      },
      deep: true
    }
  },
  methods: {
    getAreaList() {
      getAreaList().then(response => {
        this.areaList = response.data
      })
    },
    getBedRoomList() {
      getBedRoomList().then(response => {
        this.bedRoomList = response.data
      })
    },
    initMap() {
      var that = this
      this.$nextTick(() => {
        const txmap = this.$refs.map
        if (txmap !== null) {
          var center = new qq.maps.LatLng(that.htForm.lat, that.htForm.lng)
          var map = new qq.maps.Map(txmap, {
            center: center,
            zoom: 20
          })
          var anchor = new qq.maps.Point(35, 70),
            size = new qq.maps.Size(70, 70),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage('https://www.mulu.life/efile/upload/temp/map_marker.png', size, origin, anchor)
          var marker = new qq.maps.Marker({
            position: center,
            icon: icon,
            map: map,
            Draggable: true
          })
          qq.maps.event.addListener(marker, 'dragend', function() {
            var weizhi = marker.getPosition()
            that.htForm.lng = weizhi.lng
            that.htForm.lat = weizhi.lat
          })
          qq.maps.event.addListener(map, 'click', function(event) {
            that.htForm.lng = event.latLng.getLng()
            that.htForm.lat = event.latLng.getLat()
            var newcenter = new qq.maps.LatLng(that.htForm.lat, that.htForm.lng)
            marker.setPosition(newcenter)
          })
        }
      })
    },
    flushMap() {
      if (this.htForm.city.length > 0 && this.htForm.address !== null && this.htForm.address !== undefined && this.htForm.address.trim() !== '') {
        const geocoder = new qq.maps.Geocoder()
        const address = `${this.htForm.city[0]}` + `${this.htForm.city[1]}` + `${this.htForm.city[2]}` + `${this.htForm.address}`
        const that = this
        geocoder.getLocation(address)
        geocoder.setComplete(function(result) {
          that.htForm.lng = result.detail.location.lng
          that.htForm.lat = result.detail.location.lat
          that.initMap()
        })
      } else {
        this.$message.error('请完善房屋地址再进行定位')
      }
    },
    exchangeFollow() {
      this.changeForm.olduserid = this.clientinfo.followid
      this.changeForm.newuserid = null
      this.changeVisible = true
    },
    SubExchange() {
      if (this.changeForm.olduserid === this.changeForm.newuserid) {
        this.$message.error('交换人不能和原跟进人相同')
        return
      }
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          if (!this.changeloading) {
            this.changeloading = true
            const data = {
              cid: this.cid,
              userid: this.user.userid,
              newuserid: this.changeForm.newuserid
            }
            exchangeFollowClient(data).then(response => {
              this.$message({
                message: '交换成功',
                type: 'success'
              })
              this.changeVisible = false
              this.changeloading = false
              this.getData()
            }).catch(() => {
              this.changeloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    addOther() {
      this.htForm.costs.push({ name: '', amount: null })
    },
    delOther(index) {
      this.htForm.costs.splice(index, 1)
    },
    getStageList() {
      getStageDictionary().then(response => {
        this.stageList = response.data
      })
    },
    submitHt() {
      this.$refs['htForm'].validate((valid) => {
        if (valid) {
          if (!this.htloading) {
            this.htloading = true
            const data = {
              cid: this.cid,
              time: this.htForm.time,
              userid: this.user.userid, // 经销商id
              imgids: this.htForm.imgids.join(','),
              costs: qs.parse(this.htForm.costs),
              name: this.htForm.name,
              custname: this.htForm.custname,
              tel: this.htForm.tel,
              province: this.htForm.city[0],
              city: this.htForm.city[1],
              county: this.htForm.city[2],
              address: this.htForm.address,
              lng: this.htForm.lng,
              lat: this.htForm.lat,
              style: this.htForm.style,
              area: this.htForm.area,
              house: this.htForm.house,
              designer: this.htForm.designer,
              customer: this.htForm.customer,
              sales: this.htForm.sales,
              foreman: this.htForm.foreman,
              stages: this.htForm.stages.join(',')
            }
            signDealerClientContract(data).then(response => {
              this.$message({
                message: '合同签订成功',
                type: 'success'
              })
              this.htVisible = false
              this.htloading = false
              this.getData()
            }).catch(() => {
              this.htloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    openHtqd() {
      this.htimgLoad = new Date().getTime()
      let city = []
      if (this.clientinfo.county !== null && this.clientinfo.county !== '' && this.clientinfo.county !== undefined) {
        if (this.clientinfo.province !== null && this.clientinfo.province !== '' && this.clientinfo.province !== undefined) {
          city.push(this.clientinfo.province)
        }
        if (this.clientinfo.city !== null && this.clientinfo.city !== '' && this.clientinfo.city !== undefined) {
          city.push(this.clientinfo.city)
        }
        city.push(this.clientinfo.county)
      }
      this.htForm = {
        time: '',
        name: '',
        custname: this.clientinfo.name,
        tel: this.clientinfo.tel,
        city: city,
        address: this.clientinfo.address,
        lng: '',
        lat: '',
        style: this.clientinfo.style,
        area: '',
        house: '',
        designer: '',
        customer: '',
        sales: '',
        foreman: '',
        stages: ['竣工', '验收'],
        costs: [{ name: '', amount: null }],
        imgids: [],
        amount: 0
      }
      this.htVisible = true
      if (city.length === 3 && this.htForm.address !== null && this.htForm.address !== undefined && this.htForm.address !== '') {

      }
      this.initMap()
    },
    getDealerGroup() {
      getDealerGroupReport({ delid: this.user.delid }).then(response => {
        this.deluserlst = response.data.userlst
      })
    },
    voidClient() {
      this.$prompt('此操作将此客户作废，请输入原因并确定以继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '原因不可为空'
      }).then(({ value }) => {
        const data = {
          cid: this.cid,
          dcfid: 0,
          type: 0,
          remark: value,
          label: this.followForm.labels.join(','),
          userid: this.user.userid
        }
        editDelClientFollow(data).then(response => {
          this.$message({
            message: '客户已作废',
            type: 'success'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    viewRecord() {
      this.viewData = []
      this.viewVisible = true
      this.dloading = true
      const data = {
        cuserid: this.cuserid,
        page: 1,
        limit: 99999999
      }
      getBrowsinghistoryList(data).then(response => {
        this.dloading = false
        this.viewData = response.data
      }).catch(() => {
        this.dloading = false
      })
    },
    getBrandList() {
      getDealerDetail({ delid: this.user.delid }).then(response => {
        if (response.data.brandlst.length > 0) {
          this.bid = response.data.brandlst[0].bid
          this.getStyleList()
        }
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        let _styleList = []
        for (const s of response.data) {
          if (s.bid === this.bid) {
            _styleList.push(s)
          }
        }
        this.styleList = _styleList
      })
    },
    getDelClientGroupList() {
      getDelClientGroupList({ userid: this.user.userid }).then(response => {
        const group = []
        for (const g of response.data) {
          if (g.groupid > 3) {
            group.push({ value: g.groupid, label: g.name })
          }
        }
        this.groupoptions = group
      })
    },
    getDelClientTagList() {
      getDelClientTagList({ userid: this.user.userid }).then(response => {
        this.tagaoption = response.data
      }).catch(() => {})
    },
    addTags() {
      this.$prompt('请输入标签名称', '添加标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '标签名称不可为空'
      }).then(({ value }) => {
        editDelClientTag({ userid: this.user.userid, tagid: 0, name: value }).then(response => {
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTags(tagid) {
      this.$confirm('此操作将永久删除此标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDelClientTag({ tagid: tagid }).then(response => {
          this.followForm.labels = []
          this.getDelClientTagList()
        }).catch(() => {})
      }).catch(() => {})
    },
    getData() {
      if (this.cid != null && this.cid !== undefined && this.cid !== '') {
        this.loading = true
        getDelClientInfo({ cid: this.cid }).then(response => {
          this.loading = false
          const pageTitle = `客户主页 - ${response.data.name}`
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, { title: pageTitle })
          this.$store.dispatch('tagsView/updateVisitedView', route)
          this.clientinfo = response.data
          const lab = []
          for (const tag of this.clientinfo.tagList) {
            lab.push(tag.tagid)
          }
          this.followForm.labels = lab
          this.cuserid = response.data.userid
          this.getDelClientFollowList()
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.$message.error('获取客户信息失败')
      }
    },
    getDelClientFollowList() {
      getDelClientFollowList({ cid: this.cid }).then(response => {
        this.followList = response.data
      }).catch(() => {})
    },
    editInfo() {
      this.infodialogVisible = true
      this.infoForm.name = this.clientinfo.name
      this.infoForm.tel = this.clientinfo.tel
      this.infoForm.weixin = this.clientinfo.wchat
      this.infoForm.sex = this.clientinfo.sex
      let city = []
      if (this.clientinfo.province !== null && this.clientinfo.province !== '' && this.clientinfo.province !== undefined) {
        city.push(this.clientinfo.province)
      }
      if (this.clientinfo.city !== null && this.clientinfo.city !== '' && this.clientinfo.city !== undefined) {
        city.push(this.clientinfo.city)
      }
      if (this.clientinfo.county !== null && this.clientinfo.county !== '' && this.clientinfo.county !== undefined) {
        city.push(this.clientinfo.county)
      }
      this.infoForm.city = city
      this.infoForm.address = this.clientinfo.address
      this.infoForm.area = this.clientinfo.area
      this.infoForm.style = this.clientinfo.style
      if (this.clientinfo.groupid > 3) {
        this.infoForm.groupid = this.clientinfo.groupid
      } else {
        this.infoForm.groupid = null
      }
      this.infoForm.labels = this.followForm.labels
      this.infoForm.remark = this.clientinfo.remark
      this.infoForm.isgoto = this.clientinfo.isgoto
      this.infoForm.gototime = this.clientinfo.gototime
    },
    subClientInfo() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          if (!this.editinfoloading) {
            this.editinfoloading = true
            const data = {
              cid: this.cid,
              name: this.infoForm.name,
              tel: this.infoForm.tel,
              wchat: this.infoForm.weixin,
              sex: this.infoForm.sex,
              province: this.infoForm.city[0],
              city: this.infoForm.city[1],
              county: this.infoForm.city[2],
              address: this.infoForm.address,
              area: this.infoForm.area,
              style: this.infoForm.style,
              groupid: this.infoForm.groupid,
              remark: this.infoForm.remark,
              delid: this.user.delid,
              label: this.infoForm.labels.join(','),
              userid: this.user.userid,
              isgoto: this.infoForm.isgoto,
              gototime: this.infoForm.gototime
            }
            editDelClientInfo(data).then(response => {
              this.$message({
                message: '客户信息修改成功',
                type: 'success'
              })
              this.infodialogVisible = false
              this.editinfoloading = false
              this.getData()
            }).catch(() => {
              this.editinfoloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editFollow(row) {
      this.editfollowloading = false
      if (row === null) {
        this.followTitle = '添加跟进记录'
        this.followForm.dcfid = 0
        this.followForm.type = 1
        this.followForm.remark = ''
        this.followForm.imgids = []
        this.oldimgList = []
      } else {
        this.followTitle = '编辑跟进记录'
        this.followForm.dcfid = row.dcfid
        this.followForm.type = row.type
        this.followForm.remark = row.content
        const _oldimgList = []
        for (const img of row.imgList) {
          _oldimgList.push({ id: img.imgid, url: img.imgurl })
        }
        this.oldimgList = _oldimgList
      }
      this.imgLoad = new Date().getTime()
      this.followVisible = true
    },
    submitFollow() {
      this.$refs['followForm'].validate((valid) => {
        if (valid) {
          if (!this.editfollowloading) {
            this.editfollowloading = true
            const data = {
              cid: this.cid,
              dcfid: this.followForm.dcfid,
              type: this.followForm.type,
              remark: this.followForm.remark,
              imgids: this.followForm.imgids.join(','),
              label: this.followForm.labels.join(','),
              userid: this.user.userid
            }
            editDelClientFollow(data).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.followVisible = false
              this.editfollowloading = false
              this.getData()
            }).catch(() => {
              this.editfollowloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    change(n) {
      if (this.browsetype === n) {
        return false
      }
      this.browsetype = n
      this.browseCurrentPage = 1
      this.browsePageSize = 20
      if (this.browsetype === 1) {
        this.getDelClientShowHomeBrowse()
      } else if (this.browsetype === 2) {
        this.getDelClientCaseBrowse()
      } else if (this.browsetype === 3) {
        this.getDelClientStrategyBrowse()
      }
    },
    handleSizeChange(val) {
      this.browsePageSize = val
      if (this.browsetype === 1) {
        this.getDelClientShowHomeBrowse()
      } else if (this.browsetype === 2) {
        this.getDelClientCaseBrowse()
      } else if (this.browsetype === 3) {
        this.getDelClientStrategyBrowse()
      }
    },
    handleCurrentChange(val) {
      this.browseCurrentPage = val
      if (this.browsetype === 1) {
        this.getDelClientShowHomeBrowse()
      } else if (this.browsetype === 2) {
        this.getDelClientCaseBrowse()
      } else if (this.browsetype === 3) {
        this.getDelClientStrategyBrowse()
      }
    },
    getDelClientShowHomeBrowse() {
      this.browseLoading = true
      const data = {
        userid: this.cuserid,
        page: this.browseCurrentPage,
        limit: this.browsePageSize
      }
      getDelClientShowHomeBrowse(data).then(response => {
        this.browseLoading = false
        this.browseList = response.data
        this.browsetotal = response.total
      }).catch(() => {
        this.browseLoading = false
      })
    },
    getDelClientCaseBrowse() {
      this.browseLoading = true
      const data = {
        userid: this.cuserid,
        page: this.browseCurrentPage,
        limit: this.browsePageSize
      }
      getDelClientCaseBrowse(data).then(response => {
        this.browseLoading = false
        this.browseList = response.data
        this.browsetotal = response.total
      }).catch(() => {
        this.browseLoading = false
      })
    },
    getDelClientStrategyBrowse() {
      this.browseLoading = true
      const data = {
        userid: this.cuserid,
        page: this.browseCurrentPage,
        limit: this.browsePageSize
      }
      getDelClientStrategyBrowse(data).then(response => {
        this.browseLoading = false
        this.browseList = response.data
        this.browsetotal = response.total
      }).catch(() => {
        this.browseLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .client-container {
    .card-content{
      .browse-filter{
        width: 100%;
        padding: 0 30px 0 0 ;
        margin: 0 ;
        position: relative;
        li{
          width: 100%;
          list-style: none;
          position: relative;
          padding-left: 20px;
          padding-top: 15px;
          padding-bottom: 15px;
          cursor: pointer;
          border-radius: 2px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &.active{
            background: #f5f7fa;
            color:#409EFF;
          }
          &:hover{
            color:#409EFF;
          }
        }
      }
    }
  .client-name{
    letter-spacing: 2px;
    color:#000;
  }
  .client-info-row{
    padding:6px 0;
  }
  .row-line{
    border-bottom: 1px solid #f5f7fa;
    padding-bottom: 14px;
    margin-bottom: 10px;
  }
  .client-sex{
    width: 16px!important;
    height: 16px!important;
    vertical-align: -4px!important;
  }
  .follow-txt{
    font-size: 13px;
  }
  .follow-content{
    color:#999;
    font-size: 13px;
  }
  .follow-editbtn{
    position: absolute;
    right:20px;
    top:40px;
  }
    .photo{
      width: 100px;
      height: 100px;
      position: absolute;
      left: 20px;
      top:20px;
    }
    .info{
      position: relative;
      padding-right: 40px;
      width: 100%;
      .username{
        margin-bottom: 6px;
        span{
          &:first-child{
            font-size: 13px;
            font-weight: 500;
            margin-right: 6px;
          }
        }
      }
      .content{
        margin-bottom: 6px;
        font-size: 13px;
      }
      .imgs{
        .dynamic-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
    &:last-child{
      border-bottom: 0px;
    }
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
  .tags-item{
    position: relative;
    padding: 9px 15px;
    background: #FFF;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
    display: inline-block;
    color: #606266;
    font-size: 12px;
    font-weight: 500;
    margin:0 20px 20px 0;
  .tags-del{
    padding: 2px!important;
    font-size: 10px!important;
    position: absolute;
    right: -10px;
    top: -6px;
  }
  }
  }
  }
</style>
